module.exports = __webpack_public_path__ + "img/QC.67434e38.png";